import { CasualTournamentDetails } from '@fantaz/shared/data-access/models';
import { Action, createReducer, on } from '@ngrx/store';
import { loadSubscriptionTournamentSuccess } from '../casual-tournament/casual-tournament.actions';
import * as CasualTournamentDetailsActions from './casual-tournament-details.actions';

export const CASUAL_TOURNAMENT_DETAILS_FEATURE_KEY = 'casualTournamentDetails';

export interface CasualTournamentDetailsState {
  details?: CasualTournamentDetails | null;
  loaded: boolean;
  userTimesPlayed: number;
  error?: any | null; // last known error (if any)
}

export interface CasualTournamentDetailsPartialState {
  readonly [CASUAL_TOURNAMENT_DETAILS_FEATURE_KEY]: CasualTournamentDetailsState;
}

export const initialState: CasualTournamentDetailsState = {
  details: null,
  loaded: false,
  error: null,
  userTimesPlayed: 0,
};

const reducer = createReducer(
  initialState,
  on(CasualTournamentDetailsActions.loadCasualTournamentDetails, (state) => ({
    ...state,
    details: null,
    loaded: false,
    error: null,
  })),
  on(CasualTournamentDetailsActions.clearCasualTournamentDetails, (state) => {
    return {
      ...state,
      details: null,
      loaded: false,
      error: null,
    };
  }),
  on(
    CasualTournamentDetailsActions.loadCasualTournamentDetailsSuccess,
    (state, { casualTournamentDetails }) => ({
      ...state,
      loaded: true,
      details: casualTournamentDetails,
    }),
  ),
  on(
    CasualTournamentDetailsActions.loadCasualTournamentRatingSuccess,
    (state, { casualTournamentRating }) => {
      const details = Object.assign({}, state.details, casualTournamentRating);
      return {
        ...state,
        loaded: true,
        details: details,
      };
    },
  ),
  on(loadSubscriptionTournamentSuccess, (state, { eventSchedule, status }) => {
    if (state.details) {
      const schedules = state.details?.detailsForEventSchedule.map((e) => {
        if (e.eventScheduleUuid === eventSchedule.uuid) {
          return { ...e, subscriptionStatus: status };
        }
        return e;
      });
      return {
        ...state,
        details: { ...state.details, detailsForEventSchedule: schedules },
      };
    }
    return state;
  }),
  on(
    CasualTournamentDetailsActions.loadCasualTournamentDetailsSubscribed,
    (state, { eventScheduleUuid, status }) => {
      if (state.details) {
        const schedules = state.details?.detailsForEventSchedule.map((e) => {
          if (e.eventScheduleUuid === eventScheduleUuid) {
            return { ...e, subscriptionStatus: status };
          }
          return e;
        });
        return {
          ...state,
          details: { ...state.details, detailsForEventSchedule: schedules },
        };
      }
      return state;
    },
  ),
  on(
    CasualTournamentDetailsActions.loadCasualTournamentDetailsFailure,
    (state, { error }) => ({ ...state, error }),
  ),
  on(
    CasualTournamentDetailsActions.timesUserTournamentPlayedSuccess,
    (state, { timesPlayed }) => ({ ...state, userTimesPlayed: timesPlayed }),
  ),
);

export function casualTournamentDetailsReducer(
  state: CasualTournamentDetailsState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
